// ============================================================
// AUTH CONTEXT - Admin authentication state
// ============================================================

import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminService } from '../services/adminService';

const AuthContext = createContext(null);

const AUTH_KEY = 'fazlic_admin_token';

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(AUTH_KEY);
    if (!token) {
      setIsLoading(false);
      return;
    }

    adminService.getMe()
      .then((adminData) => {
        setIsAuthenticated(true);
        setAdmin(adminData);
      })
      .catch(() => {
        localStorage.removeItem(AUTH_KEY);
        setIsAuthenticated(false);
        setAdmin(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const login = (token, adminData) => {
    localStorage.setItem(AUTH_KEY, token);
    setIsAuthenticated(true);
    setAdmin(adminData);
  };

  const logout = () => {
    adminService.logout();
    setIsAuthenticated(false);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, admin, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
